// A refused or failed read is the decided „no value“: its chips stay marked.
export async function bodyOrNull<T>(
  read: () => Promise<{ readonly ok: boolean; readonly body: unknown }>,
): Promise<T | null> {
  try {
    const result = await read();

    return result.ok ? (result.body as T) : null;
  } catch {
    return null;
  }
}
